<ng-template let-item>
    <span class="w-100">
        <app-role-value-label-template [row]="item"></app-role-value-label-template>
    </span>
</ng-template>
